import { create } from 'zustand';
import type { Preset } from '@wg/shared';

type PresetState = {
  presets: Preset[];
  loading: boolean;
  error: string | null;
  set: (p: Preset[]) => void;
  setLoading: (b: boolean) => void;
  setError: (e: string | null) => void;
};

export const usePresetStore = create<PresetState>((set) => ({
  presets: [],
  loading: false,
  error: null,
  set: (presets) => set({ presets }),
  setLoading: (loading) => set({ loading }),
  setError: (error) => set({ error }),
}));
